export const isValueNumber = value => {
  if (value === '') {
    return false;
  }
  if (value === null || value === undefined) {
    return false;
  }
  if (Number.isNaN(Number(value))) {
    return false;
  }
  return true;
};